<template>
  <div class="row">
    <config-menu></config-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN')">
        <toast ref="toast"></toast>

        <card class='stripe-card'
          :class='{ complete }'
          stripe='pk_test_ATB0BR6wa6qxRztqsPZbSzrH'
          :options='stripeOptions'
          @change='complete = $event.complete'
        />
        <button class='pay-with-stripe btn btn-primary btn-sm mt-1' @click='createToken' :disabled='!complete'>更新</button>
    </div>
  </div>
</template>

<style scoped>
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
</style>

<script>
import CommonAPI from "../../../api/common-api.js";
import CompanyAPI from "../../../api/company-api.js";
import ConfigMenu from "./ConfigMenu.vue";
import Toast from '../../Toast.vue'

import { Card, createToken } from 'vue-stripe-elements-plus'

export default {
  name: "config",
  components: {
    Toast,
    ConfigMenu,
    Card,
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = val
    },
  },  
  data() {
    return {
      edit: false,
      loginUser: {
          role: ''
      },
      company: {},
      complete: false,
      stripeOptions: {},
    }
  },
  mounted () {
    this.getCompany()
  },
  methods: {
    // 設定取得
    getCompany () {
      this.$root.$refs.loading.$data.show = true
      CompanyAPI.get()
          .then(res => {
            this.company = res
            this.$nextTick(function() {
              $(".close").click()
              this.$root.$refs.loading.$data.show = false
            })
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // トークン取得
    createToken () {
      this.$root.$refs.loading.$data.show = true
      createToken()
        .then(function (data){
          var param = {
            token: data.token.id
          }
          CompanyAPI.updateCreditCard(param)
            .then(res => {
              this.$root.$refs.loading.$data.show = false;
              this.$refs.toast.showToast("更新しました", 3000, false)
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
        }.bind(this))
    }
  },
  filters: {
    settingEmpty: function (data) {
      return data ? data : '設定なし'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/config/ConfigCard.vue